import ResourceService from "./ResourcesService";

export default ResourceService;
